var messenger = "https://shopfront-cdn.tekoapis.com/static/71a0547de8dec349.svg";

export { messenger as default };
